import { IconName } from '@uikit/svg-icon';

export enum Size {
    large = 'large',
    normal = 'normal',
    medium = 'medium',
    semiSmall = 'semiSmall',
    small = 'small',
    big = 'big',
}

export enum Shape {
    rounded = 'rounded',
    circle = 'circle',
    hexagon = 'hexagon',
    square = 'square',
}
export enum BorderColor {
    gold = 'gold',
    violet = 'violet',
    pink = 'pink',
    blue = 'blue',
}

export enum Badge {
    heart = 'heart',
    userSingle = 'userSingle',
    creator = 'creator',
    producer = 'producer',
}

export const Icons = {
    [Badge.heart]: IconName.Heart,
    [Badge.creator]: IconName.Creator,
    [Badge.producer]: IconName.Creator,
    [Badge.userSingle]: IconName.UserHeader,
};
